import styled from 'styled-components';
import { palette } from 'styled-tools';

import { COLLAPSED_AUDIO_PLAYER_INDEX } from '@/utils/ui/zIndices';

export const UPSELL_FOOTER_HEIGHT = '92px';

export const UpsellFooterWrapper = styled.a`
	width: 100%;
	height: ${UPSELL_FOOTER_HEIGHT};
	background: ${palette('upsellFooterBackgroundGradient')};
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	bottom: 0;
	z-index: ${COLLAPSED_AUDIO_PLAYER_INDEX + 2};
	/* No-op today since the viewport meta doesn't opt into safe-area insets;
	 * kept so this fixed bar stays clear of the home-indicator gesture area
	 * if that ever changes. */
	padding-bottom: env(safe-area-inset-bottom);
`;

export const UpsellFooterContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 770px;

	button {
		margin-left: 24px;
	}
`;
